<template>
  <div class="ViewSafeAdvantages">
    <h2 class="ViewSafeAdvantages__title">ПРЕИМУЩЕСТВА СЕРВИСА</h2>
    <div class="ViewSafeAdvantages__row">
      <div class="ViewSafeAdvantages__col">
        <div class="app-it-advantage">
          <app-svg-icon
            name="oil3"
            class="app-it-advantage__icon ViewSafeAdvantages__icon"
          ></app-svg-icon>
          <div class="app-it-advantage__title">Покупателям</div>
          <div class="app-it-advantage__desc ViewSafeAdvantages__desc">
            <ul class="ViewSafeAdvantages__list">
              <li class="ViewSafeAdvantages__list-item">
                Покупаете нужный объём без излишков, остаток денег возвращается
                на ваш р/сч автоматически
              </li>
              <li class="ViewSafeAdvantages__list-item">
                Продавец гарантирует качественный товар, так как деньги ему
                поступят только после вашего подтверждения, что товар получен
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="ViewSafeAdvantages__col">
        <div class="app-it-advantage">
          <app-svg-icon
            name="oil2"
            class="app-it-advantage__icon ViewSafeAdvantages__icon"
          ></app-svg-icon>
          <div class="app-it-advantage__title">Поставщикам</div>
          <div class="app-it-advantage__desc ViewSafeAdvantages__desc">
            <ul class="ViewSafeAdvantages__list">
              <li class="ViewSafeAdvantages__list-item">
                Продаете напрямую благонадежным покупателям. Деньги за
                отгружаемый Покупателю Товар уже получены Маркетплейсом и
                хранятся на номинальном счете до исполнения сделки по его
                поставке Покупателю.
              </li>
              <li class="ViewSafeAdvantages__list-item">
                Покупатель больше доверяет, а значит отдает приоритет вам, как
                новому поставщику и повышает ваш рейтинг при последующих заказах
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewSafeAdvantages',
  components: { AppSvgIcon: () => import('@/components/common/AppSvgIcon') },
};
</script>

<style lang="scss">
.ViewSafeAdvantages {
  $root: &;

  &__icon {
    @include size(94px);

    @include media-xs() {
      @include size(64px);
    }
  }

  &__title {
    margin-bottom: rem(30);
    font-size: rem(36);
    font-weight: 700;
    line-height: 1.2;
    color: #009f5c;
    text-align: center;
    text-transform: uppercase;

    @include media-sm() {
      margin-bottom: rem(10);
      font-size: rem(24);
    }
  }

  &__desc {
    max-width: calc(100% - 100px);

    @include media-xs() {
      max-width: calc(100% - 70px);
    }
  }

  &__list {
    padding-left: 0;
    list-style: none;
  }

  &__list-item {
    position: relative;
    padding-left: rem(30);

    &::before {
      position: absolute;
      top: rem(7);
      left: 0;
      display: block;
      content: '';
      background: #02b65f;
      border-radius: 50%;

      @include size(7px);
    }

    &:not(:last-child) {
      margin-bottom: rem(20);
    }
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-bottom: -15px;
    margin-left: -15px;
  }

  &__col {
    flex-grow: 1;
    width: calc(50% - 30px);
    margin: 15px;

    @include media-sm() {
      width: calc(100% - 30px);
    }
  }
}
</style>
